import React from 'react';
import { Helmet } from "react-helmet";
import { Col, Row, Container, Card, CardBody } from 'reactstrap';
// Local Deps
import './Contact.scss';
import msgs from '../../../config/messages';
import meldingImage from '../../../images/features/melding.png';
import iconLogoFull from '../../../images/icon-logo.png';

export default function Contact() {
  return (
    <Container fluid className="p-0">
      <Helmet>
        <meta charSet="utf-8" />
        <title>NFFS ICON - Contact Us</title>
        <meta name="description" content="The ICON Portal is managed by the Non-Ferrous Founders' Society, a North American foundry trade association." />
        <meta name="keywords" content="NFFS, NFFS phone number, AMC, contact NFFS" />
      </Helmet>

      {/* Hero Banner */}
      <div className="contact-hero">
        <div className="contact-hero-background" style={{ backgroundImage: `url(${meldingImage})` }} />
        <Container>
          <div className="contact-hero-content">
            <img
              src={iconLogoFull}
              alt="ICON Logo"
              style={{
                maxWidth: '340px',
                width: '100%',
                height: 'auto',
                margin: '0 auto 18px auto',
                display: 'block',
                objectFit: 'contain',
              }}
            />
            <h1>Contact Us</h1>
            <p className="lead">
              We&apos;re here to help with any questions about the ICON platform.
            </p>
          </div>
        </Container>
      </div>

      <Container className="nf-contact-page">
        <Row className="justify-content-center">
          <Col md={10} lg={8}>
            <Card className="contact-card">
              <CardBody>
                <div className="contact-intro">
                  <p>{msgs.Contact.section1.text}</p>
                </div>

                <div className="contact-details">
                  <h3>{msgs.Contact.section2.header}</h3>

                  <div className="contact-person">
                    <p className="contact-name">{msgs.Contact.address.name}</p>
                    <p className="contact-org">{msgs.Contact.address.company}</p>

                    <div className="contact-info">
                      <div className="contact-info-item">
                        <span className="contact-label"><i className="fa fa-phone" /> {msgs.Form.phoneLabel}</span>
                        <a href={`tel:${msgs.Contact.address.phone}`} className="contact-value">{msgs.Contact.address.phone}</a>
                      </div>

                      <div className="contact-info-item">
                        <span className="contact-label"><i className="fa fa-envelope" /> {msgs.Form.emailLabel}</span>
                        <a href={`mailto:${msgs.Contact.address.email}?bcc=support@nffs.atlassian.net&subject=ICON%20Portal%20Contact%20Request&body=Please%20describe%20your%20inquiry%20below%3A%0A%0A`} className="contact-value">{msgs.Contact.address.email}</a>
                      </div>
                    </div>
                  </div>
                </div>
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Container>
  );
}



// WEBPACK FOOTER //
// ./src/pages/static/Contact/Contact.jsx